import requests from "./httpService";

const StateServices = {

  addState: async (body) => {
    return requests.post("/state/add", body);
  },
  getAllState: async (body) => {
    return requests.get("/state/", body);
  },
  getStateById: async (id, body) => {
    return requests.get(`/state/${id}`, body);
  },
  getStateByIdOne: async (id, body) => {
    return requests.get(`/state/get/${id}`, body);
  },
  getStateByCountryID: async (id, body) => {
    return requests.get(`/state/stateByCountry/${id}`, body);
  },

  updateState: async (id, body) => {
    return requests.put(`/state/update/${id}`, body);
  },

  deleteState: async (id) => {
    return requests.delete(`/state/delete/${id}`);
  },
 
};

export default StateServices;
